import { render, staticRenderFns } from "./PeopleCard.vue?vue&type=template&id=2b69d651&scoped=true&"
import script from "./PeopleCard.vue?vue&type=script&lang=js&"
export * from "./PeopleCard.vue?vue&type=script&lang=js&"
import style0 from "./PeopleCard.vue?vue&type=style&index=0&id=2b69d651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69d651",
  null
  
)

export default component.exports